class MediaGallery extends HTMLElement {
  connectedCallback() {
    const modal   = this.querySelector('.product-gallery-modal');
    const closeBtn = modal.querySelector('.product-gallery-modal__close');

    // Thumbnail Swiper — desktop only (must init before main for thumbs to link)
    let thumbsSwiper = null;
    if (window.matchMedia('(min-width: 990px)').matches) {
      const prevBtn = this.querySelector('.product-gallery__thumbs-btn--prev');
      const nextBtn = this.querySelector('.product-gallery__thumbs-btn--next');

      thumbsSwiper = new Swiper(this.querySelector('.product-gallery__thumbs'), {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
      });

      const updateThumbsNav = () => {
        prevBtn.classList.toggle('is-hidden', thumbsSwiper.isBeginning);
        nextBtn.classList.toggle('is-hidden', thumbsSwiper.isEnd);
      };

      updateThumbsNav();
      thumbsSwiper.on('slideChange', updateThumbsNav);
      prevBtn.addEventListener('click', () => thumbsSwiper.slidePrev());
      nextBtn.addEventListener('click', () => thumbsSwiper.slideNext());
    }

    // Main gallery Swiper
    this.gallerySwiper = new Swiper(this.querySelector('.product-gallery__swiper'), {
      pagination: {
        el: this.querySelector('.product-gallery__fraction'),
        type: 'fraction',
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      grabCursor: true,
    });

    // Modal Swiper
    const modalSwiper = new Swiper(modal.querySelector('.product-gallery-modal__swiper'), {
      pagination: {
        el: modal.querySelector('.product-gallery-modal__fraction'),
        type: 'fraction',
      },
      navigation: {
        prevEl: '.product-gallery-modal__swiper .swiper-button-prev',
        nextEl: '.product-gallery-modal__swiper .swiper-button-next',
      },
      zoom: {
        maxRatio: 3,
        toggle: true,
        panOnMouseMove: true,
      },
      keyboard: { enabled: true },
      grabCursor: true,
    });

    const openModal = (index) => {
      modalSwiper.slideTo(index, 0);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    this.querySelector('.product-gallery__swiper').addEventListener('click', (e) => {
      const slide = e.target.closest('.product-gallery__slide');
      if (!slide) return;
      openModal(parseInt(slide.dataset.mediaIndex, 10));
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  // Called by product-info.js when the selected variant changes
  setActiveMedia(mediaId) {
    const slide = this.querySelector(`.product-gallery__slide[data-media-id="${mediaId}"]`);
    if (!slide || !this.gallerySwiper) return;
    const slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
    const index = slides.indexOf(slide);
    if (index !== -1) this.gallerySwiper.slideTo(index, 300);
  }
}

customElements.define('media-gallery', MediaGallery);
